import { defaultAxios } from '..';

let timer: any;

const authService = {
  authenticateGoogle: async (token: string, isDashbord: boolean) => {
    try {
      const res = await defaultAxios.post('/users/google', {
        token,
        isDashbord,
      });
      return res.data;
    } catch (e) {
      console.error(e);
    }
  },
  authCheck: async () => {
    try {
      const res = await defaultAxios.get('/users/check');
      return res.data;
    } catch (e) {
      try {
        // 토큰 갱신 시도
        await defaultAxios.get('/auth/refresh');
        // 인증 상태 재확인
        const res = await defaultAxios.get('/users/check');
        return res.data;
      } catch (e) {
        return false;
      }
    }
  },
  authVerify: async (token: string, type: string) => {
    try {
      const res = await defaultAxios.post(`/auth/verify?vendor_type=${type}`, {
        oauth_token: token,
      });
      return res.data;
    } catch (e) {
      console.error(e);
    }
  },
  authMicrosoftVerify: async (code: string) => {
    try {
      const res = await defaultAxios.post('/auth/verify/microsoft', {
        oauth_token: code,
      });
      return res.data;
    } catch (e) {
      console.error(e);
    }
  },
  inviteWorkspace: async (code: string) => {
    try {
      const res = await defaultAxios.put(`workspaces/${code}/join`);
      return res.data;
    } catch (e) {
      const error = e as any;
      if (error.response) {
        if (error.response.status === 409) {
          return false;
        } else if (error.response.status === 406) {
          return { isDuplicated: true };
        }
      }
      return false;
    }
  },
  getInviteCode: async (alias: string, isViewer: boolean) => {
    const res = await defaultAxios.get(
      `workspaces/${alias}/invite_code?viewer=${isViewer ? 1 : 0}`,
    );
    return res.data;
  },
  logout: async () => {
    await defaultAxios.post('/auth/logout');
    timer && clearTimeout(timer);
    return true;
  },
};

export default authService;
